import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import { withPropsOnChange } from 'recompose';
import { omit } from 'lodash';

import Subscription from '../components/Subscription';
import {
  fetchSubscription,
  updateSubscription,
  addSubscription,
} from '../actions';
import { getSubscription } from '../reducers/subscription';
import { fetchAllSubscriptionPlans } from '../../subscriptionPlans/actions';
import { getSubscriptionPlans } from '../../subscriptionPlans/reducer';
import { fetchBrand } from '../../brands/actions';
import withNotifications from '../../../common/withNotifications';

const mapStateToProps = (state, props) => ({
  subscription: getSubscription(state),
  brandId: props.params.id,
  subscriptionPlans: getSubscriptionPlans(state),
});

const mapDispatchToProps = {
  fetchSubscription,
  updateSubscription,
  addSubscription,
  fetchAllSubscriptionPlans,
  fetchBrand,
};

export const subscriptionHandlers = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  withHandlers({
    saveSubscription: props => async (data) => {
      if (!props.subscription) {
        await props.addSubscription(props.brandId, 'brand', data);
      } else {
        const preparedData = omit(data, ['indyCustomAppAddon']);

        // sys admins can only turn off the indyCustomAppAddon
        if (data.indyCustomAppAddon === false) {
          preparedData.indyCustomAppAddon = false;
        }

        await props.updateSubscription(props.brandId, 'brand', preparedData);
      }
      return props.fetchBrand(props.brandId).then(() => props.addNotification({
        title: 'Success',
        level: 'success',
        message: 'Subscription saved successfully!',
      }));
    },
    fetchSubscriptionPlans: props => () => props.fetchAllSubscriptionPlans(),
  }),
  withPropsOnChange(['brandId'], (props) => {
    if (props.brandId) {
      props.fetchBrand(props.brandId);
      return props.fetchSubscription(props.brandId, 'brand');
    }
    return null;
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchSubscriptionPlans();
    },
  }),
);

export default subscriptionHandlers(Subscription);
